module.exports = __webpack_public_path__ + "static/media/p2s2.7de054e4.jpg";